document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[id^="ProductSpecsVariantMap-"]').forEach((mapScript) => {
    const sectionId = mapScript.id.replace('ProductSpecsVariantMap-', '');
    let map;
    try {
      map = JSON.parse(mapScript.textContent);
    } catch (err) {
      return;
    }

    const idInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
    if (!idInput) return;

    const update = () => {
      const data = map[idInput.value];
      if (!data) return;
      Object.entries(data).forEach(([key, waarde]) => {
        const row = document.getElementById(`ProductSpecs-${key}-${sectionId}`);
        if (!row) return;
        const dd = row.querySelector('dd');
        if (waarde) {
          dd.textContent = waarde;
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      });
    };

    update();
    new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ['value'] });
  });
});